import {useMatch} from 'react-router';
import {useLocation, useSearchParams} from 'react-router-dom';

import {parseDashboardUrlHashParams} from 'common/report/dashboards/url';

export function useIsEmbedMode(): boolean {
  return Boolean(useMatch(`/project/:projectId/view?/:workspaceId?/app/:appName/embed/*`));
}

export function useHasGlobalSidenav(): boolean {
  const isEmbedMode = useIsEmbedMode();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const downloadStr = searchParams.get(`download`);
  const downloadVal = (downloadStr && Number.parseInt(downloadStr)) || 0;
  if (isEmbedMode || downloadVal !== 0) {
    return false;
  }

  if (location.pathname.endsWith(`/boards`)) {
    const dashboardUrlParams = parseDashboardUrlHashParams(location.hash.slice(1));
    return !(`tvModeEnabled` in dashboardUrlParams.parsedData && dashboardUrlParams.parsedData[`tvModeEnabled`]);
  }

  return true;
}
